<template>
  <page-header-wrapper>
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form layout="vertical">
        <standard-form-row block>
          <div class="ant-pro-page-header-search">
            <a-input-search
              size="large"
              style="width: 80%; max-width: 522px;"
              v-model="params.where.contents"
              placeholder="请输入要搜索的关键词"
              enter-button
              allow-clear
              @search="getLists()"
            />
            <a-button type="link" @click="() => (this.search = !this.search)">
              高级筛选
              <a-icon :type="search ? 'up' : 'down'" />
            </a-button>
          </div>
        </standard-form-row>
        <template v-if="search">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="类型">
                <a-radio-group v-model="params.where.p_id" @change="getLists()">
                  <a-radio-button value>全部</a-radio-button>
                  <a-radio-button value="1">问题</a-radio-button>
                  <a-radio-button value="2">答案</a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="审核状态">
                <a-radio-group v-model="params.where.state" @change="getLists()">
                  <a-radio-button value>全部</a-radio-button>
                  <a-radio-button value="2">通过</a-radio-button>
                  <a-radio-button value="1">驳回</a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="日期范围">
                <a-range-picker
                  :ranges="{
                    最近七天: [moment().subtract('days', 6), moment()],
                    今天: [moment(), moment()],
                    本月: [moment().startOf('month'), moment()]
                  }"
                  :placeholder="['开始日期', '结束日期']"
                  @change="values => handleChangeDate(values)"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </a-form>
    </a-card>

    <a-card style="margin-top: 24px;" :bordered="false">
      <div slot="extra" class="d-flex change-state">
        <table-tool-bar-list
          :columns="settingColumns"
          :element="element"
          @change="toolBarChange"
          @reload="getLists()"
        />
      </div>
      <a-table
        class="screenfull"
        :columns="columns"
        :data-source="list"
        :rowKey="record => record.id"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        :size="size"
        :bordered="false"
        :scroll="scroll"
      >
        <template slot="p_id" slot-scope="text">
          <a-avatar
            shape="square"
            size="large"
            :style="{ backgroundColor: text === 0 ? '#f56a00' : '#1890ff', verticalAlign: 'middle' }"
          >
            {{ text === 0 ? '问' : '答' }}
          </a-avatar>
        </template>
        <template
          slot="type"
          slot-scope="text"
        ><a-tag :color="TypeFilter(text).color">{{ TypeFilter(text).value }}</a-tag></template
        >
        <template slot="state" slot-scope="text, record">
          <a-switch
            v-action:state
            :checked="record.state === 2"
            @change="handleChangeState(record.id)"
            checked-children="通过"
            un-checked-children="驳回"
          />
        </template>
        <template slot="operation" slot-scope="text, record">
          <a-popconfirm
            :title="
              record.p_id === 0 ? ' 删除问题将会删除问题下所有答案，是否删除？' : '确定要删除该信息吗？'
            "
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleOnDelete(record.id)"
            v-action:delete
            class="ml-4"
          >
            <a href="#">删除</a>
          </a-popconfirm>
        </template>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { table, list } from '@/mixins' // 引入
import { StandardFormRow, TableToolBarList } from '@/components'

const columns = [
    {
        title: 'ID',
        dataIndex: 'id',
        sorter: true
    },
    {
        title: 'Type',
        dataIndex: 'p_id',
        scopedSlots: { customRender: 'p_id' }
    },
    {
        title: '评论内容',
        dataIndex: 'contents'
    },
    {
        title: '类型',
        dataIndex: 'type',
        scopedSlots: { customRender: 'type' }
    },
    {
        title: '商品',
        dataIndex: 'goods_id.title'
    },
    {
        title: '评论人',
        dataIndex: 'member.nickname'
    },
    {
        title: '审核',
        dataIndex: 'state',
        align: 'center',
        width: 100,
        fixed: 'right',
        defaultSortOrder: 'ascend',
        sorter: true,
        scopedSlots: { customRender: 'state' }
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        fixed: 'right',
        width: 100,
        scopedSlots: { customRender: 'operation' }
    }
]

const apiList = {
    getList: '/comments/questions',
    changeState: '/comments/questions/',
    delete: '/comments/questions/'
}
export default {
    name: 'CommentList',
    mixins: [table, list], // 使用mixins
    components: {
        StandardFormRow,
        TableToolBarList
    },
    data () {
        return {
            apiList,
            columns,
            settingColumns: JSON.parse(JSON.stringify(columns)), // 深度复制表头
            scroll: {
                x: 1000
            },
            params: {
                sort: {
                    state: 'asc'
                }
            }
        }
    },
    computed: {
        TypeFilter (status) {
            return function (status) {
                const statusMap = {
                    1: { value: '课程', color: 'pink' },
                    2: { value: '证书', color: 'red' },
                    3: { value: '套购', color: 'orange' }
                }
                return statusMap[status]
            }
        }
    },
    mounted () {
        this.getLists() // 获取广告位列表
    },
    methods: {

    }
}
</script>
